
import { defineComponent, PropType } from 'vue'
import { iChangedData } from '../../Metaweb'
import Listbox from 'primevue/listbox'

export default defineComponent({
    name: 'metaweb-update-changed-lists',
    components: { Listbox },
    props: { changedItem: { type: Object as PropType<iChangedData | null> } },
    data() {
        return {
            data: null as iChangedData | null
        }
    },
    watch: {
        changedItem() {
            this.loadData()
        }
    },
    async created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.data = this.changedItem as iChangedData
        }
    }
})
